import React from 'react';
import './TablePagination.css';

/**
 * Standart sayfalama: [ilk] [önceki sayı] [aktif] [sonraki sayı] [son]
 */
const TablePagination = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  disabled = false,
  className = '',
}) => {
  const page = Math.max(1, currentPage);
  const total = Math.max(1, totalPages);
  const canPrev = page > 1;
  const canNext = page < total;

  const go = (p) => {
    if (disabled) return;
    const next = Math.min(Math.max(1, p), total);
    if (next !== page && onPageChange) onPageChange(next);
  };

  return (
    <nav className={`table-pagination ${className}`.trim()} aria-label="Sayfalama">
      <button
        type="button"
        className="pagination-btn pagination-btn--icon"
        onClick={() => go(1)}
        disabled={disabled || !canPrev}
        title="İlk sayfa"
        aria-label="İlk sayfa"
      >
        <i className="fas fa-angle-double-left" aria-hidden />
      </button>
      {canPrev && (
        <button
          type="button"
          className="pagination-btn pagination-btn--number"
          onClick={() => go(page - 1)}
          disabled={disabled}
          aria-label={`Sayfa ${page - 1}`}
        >
          {page - 1}
        </button>
      )}
      <button
        type="button"
        className="pagination-btn pagination-btn--number pagination-btn--active"
        aria-current="page"
        aria-label={`Sayfa ${page}`}
      >
        {page}
      </button>
      {canNext && (
        <button
          type="button"
          className="pagination-btn pagination-btn--number"
          onClick={() => go(page + 1)}
          disabled={disabled}
          aria-label={`Sayfa ${page + 1}`}
        >
          {page + 1}
        </button>
      )}
      <button
        type="button"
        className="pagination-btn pagination-btn--icon"
        onClick={() => go(total)}
        disabled={disabled || !canNext}
        title="Son sayfa"
        aria-label="Son sayfa"
      >
        <i className="fas fa-angle-double-right" aria-hidden />
      </button>
    </nav>
  );
};

export default TablePagination;
